<template>
  <b-select ref="plainSelector" v-if="!hasSelectionGroups" v-model="resourceType">
    <option
      v-for="(item, i) in nonEmptySelectionGroups[0].entities"
      :key="i"
      :value="item.className.toLowerCase()"
    >
      <translate>
        {{ item.className[0].toUpperCase() + item.className.slice(1) }}
      </translate>
    </option>
  </b-select>
  <b-select ref="groupSelector" v-else v-model="resourceType">
    <optgroup
      v-for="(group, i) in nonEmptySelectionGroups"
      :key="i"
      :label="group.label"
    >
      <option
        v-for="(item, j) in group.entities"
        :key="j"
        :value="item.className.toLowerCase()"
      >
        <translate>
          {{ item.className[0].toUpperCase() + item.className.slice(1) }}
        </translate>
      </option>
    </optgroup>
  </b-select>
</template>

<script>
import Selection from '@/schema/Selection'

export default {
  props: ['value'],
  computed: {
    resourceType: {
      get () {
        return this.value
      },
      set (v) {
        this.$emit('input', v)
      }
    },
    selection () {
      return Selection(this.$store.getters['user/getUser'])
    },
    hasSelectionGroups () {
      return this.selection.filter(x => x.entities.length > 0).filter(x => x.label !== '__editable').length > 1
    },
    nonEmptySelectionGroups () {
      return this.selection.filter(x => x.entities.length > 0).filter(x => x.label !== '__editable')
    }
  },
  methods: {
    setSelection (v) {
      if (this.hasSelectionGroups) {
        this.$refs.groupSelector.selected = v
      } else {
        this.$refs.plainSelector.selected = v
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/EntityPalette.vue